import { render, staticRenderFns } from "./AsdaFooter.vue?vue&type=template&id=5cd449e1"
import script from "./AsdaFooter.vue?vue&type=script&lang=js"
export * from "./AsdaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports